import React from 'react'
import {
  Box,
  Typography,
  IconButton
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { ActionButton } from '../../action-buttons'
import { useStyles } from './style'
import { routes } from '../../../router/routes'
import { useFormFactor } from '../../../hooks'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { subscriptionSlice, trialSlice } from '../../../reducers'
import { formatShortDate, parseUnit } from '../../../pages/profile/components/subscription-and-billing/components/retention/components/plan-details/util'

export const TrialBanner = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { isMobile, isSmallTablet, isLargeTablet } = useFormFactor()
  const isTablet = isSmallTablet || isLargeTablet

  const accountInfo = useSelector(subscriptionSlice.selectors.selectAccountInfo)
  const isCancelled = accountInfo.cancelled
  const accountInfoLoaded = useSelector(
    subscriptionSlice.selectors.selectAccountInfoLoaded
  )
  const isTrialBannerDismissed = useSelector(trialSlice.selectors.selectTrialBannerDismissed)

  const handleDismiss = () => {
    dispatch(trialSlice.actions.dismissTrialBanner())
  }

  const planUnit = accountInfo.plan?.intervalUnit && parseUnit(accountInfo.plan?.intervalLength, accountInfo.plan?.intervalUnit)

  // Don't show banner if dismissed
  if (isTrialBannerDismissed) {
    return null
  }

  if (!accountInfoLoaded || !accountInfo.trialEndDate) {
    return (
      <Box className={classes.trialBanner}>
        <Box className={classes.centeredContent}>
          <Box display='flex' flexDirection='row'>
            <Typography>
              Your are currently on a free trial.
            </Typography>
          </Box>
          <ActionButton
            id='manage-trial-action'
            key='manage-trial-action'
            variant='secondary'
            component={Link}
            to={routes.profile.path}
            size='m'
            label='Manage Trial'
            data-test='manage-trial-button'
            style={{ borderRadius: '8px' }}
          />
        </Box>
        {(isMobile || isTablet) && (
          <IconButton
            onClick={handleDismiss}
            className={classes.closeButton}
            aria-label='Dismiss trial banner'
            size='small'
          >
            <CloseIcon fontSize='small' />
          </IconButton>
        )}
      </Box>
    )
  }

  return (
    <Box className={classes.trialBanner}>
      <Box className={classes.centeredContent}>
        <Box display='flex' flexDirection='row'>
          {isCancelled
            ? (
              <>
                {!(isMobile || isTablet)
                  ? (
                    <Typography>
                      Your subscription has been cancelled, but you&apos;ll still have access until <strong>{formatShortDate(accountInfo.trialEndDate)}</strong>.
                    </Typography>
                    )
                  : (
                    <Typography>
                      Your subscription has been cancelled.
                    </Typography>
                    )}
              </>
              )
            : (
              <>
                <Typography>
                  Your free trial ends on <strong>{formatShortDate(accountInfo.trialEndDate)}</strong>.
                </Typography>
                {!(isMobile || isTablet) && (
                  <Typography>
                    You&apos;ll be charged <strong>{accountInfo.nextPaymentAmount}/{planUnit}</strong> after this date unless you cancel.
                  </Typography>
                )}
              </>
              )}
        </Box>
        <ActionButton
          id='manage-trial-action'
          key='manage-trial-action'
          variant='secondary'
          component={Link}
          to={routes.profile.path}
          size='m'
          label='Manage Trial'
          data-test='manage-trial-button'
          style={{ borderRadius: '8px' }}
        />
      </Box>
      {(isMobile || isTablet) && (
        <IconButton
          onClick={handleDismiss}
          className={classes.closeButton}
          aria-label='Dismiss trial banner'
          size='small'
        >
          <CloseIcon fontSize='small' />
        </IconButton>
      )}
    </Box>
  )
}
